import { createContext, useContext } from 'react';
import type { FormDefinition } from '../format/form-definition';
import type { Edit } from './edits';

export interface BuilderContextValue {
  form: FormDefinition;
  edit(edit: Edit): void;
  selectedId: string | null;
  select(id: string): void;
  openElement(id: string): void;
  drawer: DrawerContent | null;
}

export type DrawerContent = { kind: 'form' } | { kind: 'element'; id: string };

const BuilderContext = createContext<BuilderContextValue | null>(null);

export const BuilderProvider = BuilderContext.Provider;

export const useBuilder = (): BuilderContextValue => {
  const value = useContext(BuilderContext);
  if (!value) throw new Error('A part of the Builder is rendered outside the Builder.');
  return value;
};
